import React, { useState } from 'react'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core'
import TableCell from '@material-ui/core/TableCell'
import { colors, CONSTANTS } from 'constants/index'
import moment from 'moment-timezone'
import { getItemName } from 'utils/invoice/invoice-helpers'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { navigateTo } from '../../../store/actions/navigation'
import { Avatar, Typography, ProviderPopover } from 'components'

const getInitials = (firstName, lastName) => {
  const first = firstName ? firstName.charAt(0).toUpperCase() : ''
  const last = lastName ? lastName.charAt(0).toUpperCase() : ''
  return first + last || '?'
}

const useStyles = makeStyles({
  link: {
    color: colors.BLUE_20,
    textDecoration: 'none',
  },
  void: {
    color: colors.BASIC.COLOR['80'],
    fontWeight: 500,
    fontSize: 13,
  },
  voidAmount: {
    textDecoration: 'line-through',
  },
  providerCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  providerAvatar: {
    width: 24,
    height: 24,
    fontSize: 9.75,
    fontWeight: 400,
  },
})

const InvoiceSummaryTableRow = ({ data, timezone, setInvoiceTab, currencySymbol, showProviderColumn }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const location = useLocation()
  const [providerPopoverAnchor, setProviderPopoverAnchor] = useState(null)

  const invoiceDate = moment(data.created_at)
    .tz(timezone)
    .format(CONSTANTS.DATE_FORMAT.FORMAT_ONE)

  const handleDocumentLinkClick = () => {
    if (data.type === 'I') setInvoiceTab(1)
    else dispatch(navigateTo(`${location.pathname}#${data.generated_payment_record_number}`))
  }

  const handleProviderAvatarClick = e => {
    e.stopPropagation()
    setProviderPopoverAnchor(e.currentTarget)
  }

  const handleProviderPopoverClose = () => {
    setProviderPopoverAnchor(null)
  }

  return (
    <>
      <TableCell className={classes.link} onClick={handleDocumentLinkClick}>{`${getItemName()} ${
        data.generated_payment_record_number
      }`}</TableCell>
      {showProviderColumn && (
        <TableCell>
          {data.created_by ? (
            <>
              <div className={classes.providerCell} onClick={handleProviderAvatarClick}>
                <Avatar
                  className={classes.providerAvatar}
                  src={data.created_by.photo_thumbnail || data.created_by.photo || null}
                >
                  {!data.created_by.photo_thumbnail &&
                    !data.created_by.photo &&
                    getInitials(data.created_by.first_name, data.created_by.last_name)}
                </Avatar>
              </div>
              <ProviderPopover
                provider={data.created_by}
                anchorEl={providerPopoverAnchor}
                open={Boolean(providerPopoverAnchor)}
                onClose={handleProviderPopoverClose}
              />
            </>
          ) : (
            <Typography variant="body2"></Typography>
          )}
        </TableCell>
      )}
      <TableCell>{invoiceDate}</TableCell>
      <TableCell className={classNames({ [classes.voidAmount]: data.is_void })} align={'right'}>
        {data.type === 'C' || data.type === 'P' ? '-' : ''} {currencySymbol}
        {Math.abs(data.amount).toFixed(2)}
      </TableCell>
      <TableCell align={'right'}>
        {currencySymbol}
        {data.current_invoice_amount_for_display}
      </TableCell>
      <TableCell className={classes.void}>{data.is_void ? 'VOID' : ''}</TableCell>
    </>
  )
}

export default InvoiceSummaryTableRow
